import { render } from "./VSelectSearch.vue?vue&type=template&id=411fccf3"
import script from "./VSelectSearch.vue?vue&type=script&lang=js"
export * from "./VSelectSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__